import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';

type Reason = 'expired' | 'invalid';

@Component({
  selector: 'app-auth-link-error',
  standalone: true,
  imports: [CommonModule, RouterModule, NzResultModule, NzButtonModule, TranslateModule],
  templateUrl: './auth-link-error.component.html',
  styleUrl: './auth-link-error.component.less'
})
export class AuthLinkErrorComponent implements OnInit {
  reason: Reason = 'invalid';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const qpReason = (this.route.snapshot.queryParamMap.get('reason') || '').toLowerCase();
    this.reason = qpReason === 'expired' ? 'expired' : 'invalid';
  }

  get titleKey(): string {
    return this.reason === 'expired'
      ? 'AUTH_LINK_ERROR.TITLE_EXPIRED'
      : 'AUTH_LINK_ERROR.TITLE_INVALID';
  }

  get subtitleKey(): string {
    return this.reason === 'expired'
      ? 'AUTH_LINK_ERROR.SUBTITLE_EXPIRED'
      : 'AUTH_LINK_ERROR.SUBTITLE_INVALID';
  }
}
